import Bottleneck from 'bottleneck';

import config from '../utils/config';

const reflect = (promise: Promise<any>): Promise<any> => {
    return promise.then(
        (v) => ({ v: v, status: 'fulfilled' }),
        (e) => ({ e: e, status: 'rejected' }),
    );
};

export default class RateLimiter {
    requestQueues: Map<string, Bottleneck>;

    constructor() {
        this.requestQueues = new Map();
    }

    getLimiter(key: string): Bottleneck {
        let limiter = this.requestQueues.get(key);
        if (!!limiter) {
            return limiter;
        }
        limiter = new Bottleneck({
            minTime: config.minTimeBetweenRequestsMs,
            maxConcurrent: config.maxConcurrentRequests,
        });
        this.requestQueues.set(key, limiter);
        return limiter;
    }

    // Canceling all the request promises
    clear(unlockCallback: () => void): void {
        const promises: Array<Promise<void>> = [];
        for (const [, limiter] of this.requestQueues) {
            promises.push(limiter.stop());
        }
        Promise.all(promises.map((p) => reflect(p))).then(() => {
            this.requestQueues.clear();
            unlockCallback();
        });
    }
}
